import { createSelector } from 'reselect'
import validPairsSelector from './creation_tool_valid_pairs_selector'

export default createSelector(
	[ validPairsSelector, state => state.matchingPairsCt.instructions.text ],
	(pairs, instructions) => ({
		activityData: {
			instructions,
			pairs: pairs.map(pair => ({
				id: pair.id,
				card1: {
					type: pair.card1.type,
					value: pair.card1.type === 'image' ? pair.card1.value.icon.versions.crop : pair.card1.value,
				},
				card2: {
					type: pair.card2.type,
					value: pair.card2.type === 'image' ? pair.card2.value.icon.versions.crop : pair.card2.value,
				},
			})),
		},
	})
)
